import React, { useState, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import LogoutModal from "../../components/modals/LogoutModal";

import EditIcon from "@mui/icons-material/Edit";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PaymentIcon from "@mui/icons-material/Payment";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const AccountOptionsDrowdown = ({ account }) => {
  const { user } = useContext(AuthContext);
  const [logoutmodal, setlogoutmodal] = useState(false);

  const CloseLogoutModal = () => {
    setlogoutmodal(false);
  };

  return (
    <>
      <style>
        {`
        .account-dropdown-menu {
          width: 260px;
          border-radius: 18px;
          padding: 10px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          border: none;
        }

        .account-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px;
          border-radius: 12px;
          background: #f8f9fa;
          margin-bottom: 10px;
        }

        .account-name {
          font-weight: 600;
          font-size: 14px;
        }

        .account-status {
          font-size: 12px;
          color: green;
        }

        .account-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 12px;
          border-radius: 10px;
          cursor: pointer;
          color: #444;
          font-weight: 500;
          transition: all 0.2s ease;
        }

        .account-item:hover {
          background: rgba(255, 165, 0, 0.12);
          color: orange;
        }

        .account-divider {
          height: 1px;
          background: #eee;
          margin: 6px 0;
        }

        .dropdown-toggle::after {
          display: none !important;
        }
        `}
      </style>

      <LogoutModal visibility={logoutmodal} HandleClose={CloseLogoutModal} />

      <Dropdown align="end">
        <Dropdown.Toggle className="bg-transparent border-0 p-0">
          <Avatar
            src={
              account && account.profile_pic
                ? account.profile_pic
                : null
            }
          />
        </Dropdown.Toggle>

        <Dropdown.Menu className="account-dropdown-menu">
          <div className="account-header">
            <Avatar
              src={
                account && account.profile_pic
                  ? account.profile_pic
                  : null
              }
            />
            <div>
              <div className="account-name">
                {account && account.username
                  ? account.username
                  : "Guest"}
              </div>
              <div className="account-status">Online</div>
            </div>
          </div>

          <Link to={`/u/${account && account.username}`} className="text-decoration-none">
            <div className="account-item">
              <AccountCircleIcon /> My Account
            </div>
          </Link>

          <Link to="/edit-profile" className="text-decoration-none">
            <div className="account-item">
              <EditIcon /> Edit Profile
            </div>
          </Link>

          <div className="account-divider"></div>

          <Link to="/wallet" className="text-decoration-none">
            <div className="account-item">
              <AccountBalanceWalletIcon /> Wallet
            </div>
          </Link>

          <Link to="/payments" className="text-decoration-none">
            <div className="account-item">
              <PaymentIcon /> Payments
            </div>
          </Link>

          <div className="account-divider"></div>

          <Link to="/settings" className="text-decoration-none">
            <div className="account-item">
              <SettingsIcon /> Settings
            </div>
          </Link>

          <div
            className="account-item"
            onClick={() => setlogoutmodal(true)}
          >
            <LogoutIcon /> Logout
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default AccountOptionsDrowdown;